import Ellipse from '@/app/icons/Ellipse/Ellipse'

type HorizontalBulletListProps = {
  items: string[]
} & React.HTMLAttributes<HTMLUListElement>

export function HorizontalBulletList({
  items,
  ...props
}: HorizontalBulletListProps) {
  if (!items.length) {
    return null
  }

  return (
    <ul
      {...props}
      className={`font-sans text-xs font-semibold flex flex-row gap-2 uppercase text-gray-light ${props.className ?? ''}`}
    >
      {items.map((item, index) => (
        <li key={index} className="flex items-center gap-2 leading-6">
          {index > 0 && <Ellipse className="w-1 h-1" />}
          {item}
        </li>
      ))}
    </ul>
  )
}
